import React, { useEffect } from 'react';
import { withCookies } from 'react-cookie';

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as ProcessActions from './Actions/ProcessActions';
import { setUserAccount } from './Actions/AccountActions';

import Body from './Containers/Body';

import { getMyOrder } from './Utils';

import './App.css';

function App(props) {
  useEffect(()=>{    
    getUser();
  }, []);

  const getUser = async() => {
    const { actions, onSetUserAccount } = props;
    actions.setLoading(true);
    const res = await getMyOrder();
    const { ok, user, ...rest } = res;

    if (ok) {
      onSetUserAccount(user);
      actions.setStep(4);
    }

    actions.setLoading(false);
  }

  return (
    <div className="App">
      <Body />
    </div>
  );
}


const mapStateToProps = (state) => ({

});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(ProcessActions, dispatch), 
  onSetUserAccount: (userAccount) => dispatch(setUserAccount(userAccount)),
});

export default withCookies(connect(mapStateToProps, mapDispatchToProps)(App));